module.exports = __webpack_public_path__ + "static/media/SelectDropDownBlank.1a0fd473.svg";